"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.125 1.15625C14.3125 0.96875 14.6562 0.96875 14.8438 1.15625C15.0312 1.34375 15.0312 1.6875 14.8438 1.875L8.6875 8L14.8438 14.1562C15.0312 14.3438 15.0312 14.6875 14.8438 14.875C14.6562 15.0625 14.3125 15.0625 14.125 14.875L8 8.71875L1.84375 14.875C1.65625 15.0625 1.3125 15.0625 1.125 14.875C0.9375 14.6875 0.9375 14.3438 1.125 14.1562L7.28125 8L1.125 1.875C0.9375 1.6875 0.9375 1.34375 1.125 1.15625C1.3125 0.96875 1.65625 0.96875 1.84375 1.15625L8 7.3125L14.125 1.15625Z",
    fill: "currentColor"
  }));
};

var _default = CloseIcon;
exports["default"] = _default;